import styled from 'styled-components';
import { tvar } from '../..';

interface StyledHorizontalLayoutProps {
  gap?: string;
}

export const StyledHorizontalLayout = styled.div<StyledHorizontalLayoutProps>`
  display: flex;
  align-items: center; // Align items vertically in the center
  > :first-child {
    flex: 1 0 60%; // This ensures the first child takes up 60% width
    box-sizing: border-box;
  }
  gap: ${(props) => props.gap || tvar('space.x1')};
`;
